import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import DocTemplatePageUI from './DocTemplatePageUI.js'
import { withRouter } from 'react-router'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class DocTemplatePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      objectList: null,
      downloadSubmitted: false,
      addRemarksMode: false,
      selectedFileName: '',
      selectedVersion: '',
    }
  }

  render() {
    return (
      <DocTemplatePageUI
        context={this.props.context}
        errorList={this.state.errorList}
        objectList={this.state.objectList}
        // events
        onRefreshClick={this.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={this.onCancelClick}
        onUpdate={this.onUpdate}
        onGetVersion={this.onGetVersion}
        onDownloadClick={this.onDownloadClick}
        // onAddRemarksClick={() => { this.setState({ addRemarksMode: true }) }}
        // addRemarksMode={this.state.addRemarksMode}
        // onAddRemarksCancel={() => { this.setState({ addRemarksMode: false }) }}
        onAddRemarksClick={this.onAddRemarksClick}
        addRemarksMode={this.state.addRemarksMode}
        onAddRemarksCancel={() => { this.setState({ addRemarksMode: false }) }}
        selectedFileName={this.state.selectedFileName}
        selectedVersion={this.state.selectedVersion}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getDocumentTemplates(context)
  }

  getDocumentTemplates(context) {
    const bucket = 'PUBLIC_FILES';
    const folder = 'loan_document_ftl_templates';
    let cacheManager = new CacheManager({
      resource: `/api/su/s3contents/buckets/${bucket}/folders/${folder}/objects`,
      cacheKey: CacheKeys.S3Objects(bucket, folder),
      callback: this.getDocumentTemplatesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getDocumentTemplatesCallback = (response) => {
    this.setState({ errorList: response.errorList, objectList: response.objectList })
  }

  onGetVersion = (event) => {
    let context = this.props.context
    const bucket = 'PUBLIC_FILES';
    const folder = 'loan_document_ftl_templates';
    let fileName = event.currentTarget.getAttribute('data-object-id')
    let version = event.currentTarget.getAttribute('data-version');
    this.setState({
      selectedFileName: fileName,
      selectedVersion: version,
    });
    const selectedObject = this.state.objectList.filter(list => list.fileName === fileName)[0];
    if (selectedObject.versionList) {
      selectedObject.versionList = null
      this.setState({ objectList: this.state.objectList })
      return
    }

    let cacheManager = new CacheManager({
      resource: `/api/su/s3contents/buckets/${bucket}/folders/${folder}/files/${fileName}/versions`,
      cacheKey: CacheKeys.S3ObjectVersions(bucket, folder, fileName),
      callback: this.onGetVersionCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  onGetVersionCallback = (response) => {
    const selectedObject = this.state.objectList.filter(list => list.fileName === response.fileName)[0];
    selectedObject.versionList = response.versionList;
    this.setState({ objectList: this.state.objectList }, () => {
      console.log(this.state.objectList);
    });

  }

  onDownloadClick = (event) => {
    let fileName = event.currentTarget.getAttribute('data-object-id')
    let version = event.currentTarget.getAttribute('data-version')
    const bucketName = 'PUBLIC_FILES';
    const folderName = 'loan_document_ftl_templates';
    this.setState({ selectedFileName: fileName, selectedVersion: version });
    this.setState({ selectedBucket: bucketName, downloadSubmitted: true })
    RestApiUtils.get(this.props.context,
      `/api/su/s3contents/buckets/${bucketName}/folders/${folderName}/files/${fileName}/versions/${version}/fileDownloadSignedUrl`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({ downloadSubmitted: false, downloadErrorList: response.errorList })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onAddRemarksClick = (event) => {
    const fileName = event.currentTarget.getAttribute('data-object-id');
    const version = event.currentTarget.getAttribute('data-version');
    this.setState({
      addRemarksMode: true,
      selectedFileName: fileName,
      selectedVersion: version,
    });
  }


  onRefreshClick = () => {
    const bucket = 'PUBLIC_FILES';
    const folder = 'loan_document_ftl_templates';
    CacheManager.removeObject(CacheKeys.S3Objects(bucket, folder))
    for (let object of this.state.objectList) {
      CacheManager.removeObject(CacheKeys.S3ObjectVersions(bucket, folder, object.fileName))
    }
    this.setState(
      {
        objectList: null,
        errorList: null,
      }, this.getDocumentTemplates(this.props.context)
    )
  }
}

export default withRouter(DocTemplatePageSF)


